export const categories = [
  { id: 1, name: "娱乐圈", slug: "entertainment", description: "明星八卦、影视爆料、娱乐圈最新动态", icon: "ri-star-line" },
  { id: 2, name: "网红圈", slug: "influencer", description: "网红大瓜、主播黑料、直播圈内幕", icon: "ri-live-line" },
  { id: 3, name: "社会热点", slug: "social", description: "社会事件、热点追踪、实时爆料", icon: "ri-fire-line" },
  { id: 4, name: "独家黑料", slug: "exclusive", description: "独家爆料、深度挖掘、第一手黑料", icon: "ri-spy-line" },
  { id: 5, name: "正能量", slug: "positive", description: "正能量故事、温暖瞬间、感人爆料", icon: "ri-heart-line" },
  { id: 6, name: "搞笑吃瓜", slug: "funny", description: "搞笑八卦、欢乐吃瓜、轻松一刻", icon: "ri-emotion-laugh-line" },
];

export const articles = [
  {
    id: 1,
    title: "某顶流男星深夜密会神秘女子，酒店同框照曝光引发热议",
    excerpt: "据知情人士透露，该男星与一名身穿黑色连衣裙的女子在某五星级酒店地下车库被拍到同框，两人举止亲密。",
    content: `<p>近日，有网友在某五星级酒店地下车库偶遇某顶流男星与一名神秘女子同框。</p><p>据目击者称，当晚大约11点左右，该男星驾驶一辆黑色商务车驶入酒店地下车库。几分钟后，一名身穿黑色连衣裙、戴着口罩的女子从同一辆车中走出，两人一前一后进入电梯。</p><p>值得注意的是，该男星全程表现得十分谨慎，不时四处张望，似乎担心被认出。而同行女子则一直低着头，刻意避开监控摄像头。</p><p>知情人士透露："这两人已经不是第一次被拍到了，但之前都被公关压下来了。这次的照片是路人拍摄的，所以流传出来了。"</p><p>截至目前，该男星工作室尚未对此事作出回应。而其粉丝则在社交媒体上纷纷表示"只是朋友聚会"、"等官方声明"。</p><h2>更多内幕</h2><p>有业内人士爆料，该男星近期正在与某一线女星交往，此次被拍到的神秘女子疑似是圈外人。如果属实，这或将引发新一轮的感情纠葛讨论。</p><p>我们将持续关注此事的最新进展，敬请期待后续报道。</p>`,
    category: "娱乐圈",
    categorySlug: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Dramatic%20night%20scene%20of%20luxury%20hotel%20underground%20parking%20garage%20with%20dark%20sedan%20car%2C%20two%20silhouettes%20walking%20toward%20elevator%2C%20moody%20lighting%20with%20warm%20tones%2C%20cinematic%20photography%20style%2C%20high%20contrast%2C%20mysterious%20atmosphere%2C%20night%20vibe%2C%20soft%20shadows%2C%20elegant%20composition&width=800&height=600&seq=article-cover-01&orientation=landscape",
    author: "吃瓜前线",
    publishDate: "2026-07-01",
    views: 285600,
    tags: ["顶流男星", "恋情曝光", "酒店密会", "娱乐圈"],
    featured: true,
  },
  {
    id: 2,
    title: "知名带货主播涉嫌虚假宣传，消费者集体维权索赔千万",
    excerpt: "某拥有千万粉丝的带货主播被曝销售假冒伪劣产品，目前已有多位消费者联合发起维权诉讼。",
    content: `<p>近日，某拥有超过两千万粉丝的头部带货主播陷入虚假宣传风波。</p><p>据多位消费者反映，在该主播直播间购买的一款"进口高端护肤品"使用后出现严重过敏反应，经专业机构检测后发现该产品成分与直播宣传严重不符，且未取得相关进口审批手续。</p><p>"我在她直播间花了899元买的这套护肤品，用了一次脸就红肿发痒，去医院诊断为接触性皮炎。"一位维权消费者李女士告诉记者。</p><p>目前，已有超过500名消费者加入维权群，集体索赔金额超过千万元。律师表示，如果虚假宣传行为属实，该主播及所属MCN机构将面临行政处罚和民事赔偿。</p><h2>平台回应</h2><p>涉事直播平台已发布声明，表示已对该主播账号进行暂时封禁处理，并将配合相关部门调查。但消费者认为平台的处理力度不够，要求平台承担连带责任。</p>`,
    category: "网红圈",
    categorySlug: "influencer",
    coverImage: "https://readdy.ai/api/search-image?query=Live%20streaming%20ecommerce%20studio%20scene%20with%20beauty%20products%20on%20display%20table%2C%20ring%20light%20setup%2C%20soft%20warm%20lighting%2C%20professional%20product%20photography%2C%20clean%20composition%2C%20modern%20interior%2C%20subtle%20dramatic%20mood&width=800&height=600&seq=article-cover-02&orientation=landscape",
    author: "打假先锋",
    publishDate: "2026-06-30",
    views: 198300,
    tags: ["带货主播", "虚假宣传", "消费者维权", "直播带货"],
    featured: true,
  },
  {
    id: 3,
    title: "某知名导演被曝片场耍大牌，剧组工作人员集体吐槽",
    excerpt: "一位自称在某知名导演剧组工作过的场务人员发长文爆料，控诉导演在片场的种种过分行为。",
    content: `<p>日前，一位自称在某知名导演新片剧组工作过的场务人员，在社交平台发布长文，详细描述了该导演在片场的种种"耍大牌"行为。</p><p>据该工作人员描述，导演要求全剧组每天早上五点开工，自己却经常迟到两三个小时。在拍摄期间，导演情绪极其不稳定，经常因为一点小事就对工作人员大声斥责，甚至有摔东西的行为。</p><p>"有一次因为茶水温度不够烫，他直接把杯子摔在地上，茶水溅了化妆师一身。"该工作人员写道。</p><p>此外，导演还被指对演员态度恶劣。文中称，一位新人演员因为NG了三次，被导演当众辱骂"是不是走后门进来的"，导致该演员当场落泪。</p><h2>网友反应</h2><p>此文一出，迅速引发网友热议。有网友表示"早就听说这位导演脾气大"，也有人为导演辩护称"艺术家的性格都比较偏执"。</p>`,
    category: "娱乐圈",
    categorySlug: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Film%20set%20behind%20the%20scenes%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20director%20chair%20in%20foreground%2C%20dramatic%20warm%20lighting%2C%20cinematic%20atmosphere%2C%20movie%20production%20environment%2C%20empty%20set%20with%20tension%20mood&width=800&height=600&seq=article-cover-03&orientation=landscape",
    author: "片场小透明",
    publishDate: "2026-06-29",
    views: 156700,
    tags: ["导演", "片场", "耍大牌", "剧组"],
    featured: false,
  },
  {
    id: 4,
    title: "网红情侣疑似分手，互删社交动态引发粉丝猜测",
    excerpt: "曾被誉为\"网红圈模范情侣\"的两人近日被发现在各平台互相取关并删除合照。",
    content: `<p>曾被誉为"网红圈模范情侣"的知名网红小A和小B，近日被粉丝发现在各大社交平台互相取关，并清空了所有与对方相关的动态和合照。</p><p>这一举动引发了粉丝的广泛猜测和讨论。两人自两年前公开恋情以来，一直以甜蜜互动著称，曾多次合体直播、拍摄情侣Vlog，粉丝量合计超过五千万。</p><p>有自称是两人共同好友的网友爆料称："他们其实已经冷战一个多月了，主要是因为对未来的规划有分歧。小A想继续发展事业，小B想早点结婚安定下来。"</p><p>目前双方均未对此事作出正式回应，但小B在最新的直播中被粉丝问及此事时，表情明显不自然，随后便转移了话题。</p><h2>商业影响</h2><p>值得注意的是，两人此前共同代言了多个品牌，若真的分手，这些商业合作或将受到影响。</p>`,
    category: "网红圈",
    categorySlug: "influencer",
    coverImage: "https://readdy.ai/api/search-image?query=Split%20screen%20artistic%20composition%20showing%20two%20separated%20silhouettes%20with%20warm%20and%20cool%20color%20contrast%2C%20emotional%20distance%20concept%2C%20soft%20focus%2C%20modern%20aesthetic%2C%20minimal%20style%2C%20relationship%20theme%20with%20elegant%20lighting&width=800&height=600&seq=article-cover-04&orientation=landscape",
    author: "八卦小能手",
    publishDate: "2026-06-28",
    views: 321000,
    tags: ["网红情侣", "分手", "社交动态", "感情"],
    featured: true,
  },
  {
    id: 5,
    title: "某城市地铁冲突事件完整视频流出，真相竟是这样",
    excerpt: "一段地铁车厢内的激烈冲突视频在网上疯传，但随着完整视频的曝光，事件出现了戏剧性反转。",
    content: `<p>近日，一段某城市地铁车厢内的激烈冲突视频在社交平台疯狂传播，引发广泛关注。</p><p>最初流传的片段显示，一名中年男子在地铁上对一名年轻女性大声呵斥，并将其手机打落在地。该片段迅速登上热搜，网友纷纷指责该男子"素质低下"、"欺负女性"。</p><p>然而，随着完整监控视频的流出，事件出现了戏剧性反转。原来，在该男子呵斥之前，那名年轻女性一直在用手机偷拍同车厢的另一位乘客，并在社交媒体上进行不当评论。中年男子出面制止后才发生了冲突。</p><p>"我承认我的方式有些过激，但我实在看不下去这种侵犯他人隐私的行为。"该男子事后在接受采访时表示。</p><h2>社会反思</h2><p>此事件引发了关于公共场合隐私保护、网络暴力以及"断章取义式传播"的广泛讨论。有媒体评论指出，在信息碎片化时代，公众更应该保持理性，不要被片面信息所误导。</p>`,
    category: "社会热点",
    categorySlug: "social",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20subway%20train%20interior%20with%20empty%20seats%20and%20handrails%2C%20clean%20bright%20lighting%2C%20urban%20transit%20environment%2C%20slightly%20tense%20atmosphere%2C%20warm%20metallic%20tones%2C%20editorial%20photography%20style%2C%20wide%20angle%20composition&width=800&height=600&seq=article-cover-05&orientation=landscape",
    author: "城市观察员",
    publishDate: "2026-06-27",
    views: 452000,
    tags: ["地铁冲突", "视频反转", "隐私保护", "社会热点"],
    featured: false,
  },
  {
    id: 6,
    title: "独家：某上市公司CEO私密饭局录音曝光，内容令人震惊",
    excerpt: "一段据称是某知名上市公司CEO在私人饭局上的录音被匿名人士曝光，其中涉及多起内幕交易线索。",
    content: `<p>本网独家获得一段据称是某知名上市公司CEO在私人饭局上的录音。录音中，该CEO与几位商界人士的对话内容涉及多起疑似内幕交易和信息操纵的线索。</p><p>录音时长约为45分钟，其中该CEO多次提到"提前布局"、"消息还没出"等敏感词汇，并与在场人员讨论了几只股票的买入时机。</p><p>"这个事情你先不要说出去，下周二公告一出，至少涨30%。"录音中可以清晰地听到该CEO如此表述。</p><p>经核查，录音中提到的几只股票确实在相关日期前后出现了异常波动，与录音中的描述高度吻合。</p><h2>法律分析</h2><p>法律专家表示，如果录音内容属实，该CEO的行为涉嫌违反《证券法》关于内幕交易和信息披露的相关规定，可能面临严重的法律后果。目前，相关监管部门尚未对此事发表评论。</p>`,
    category: "独家黑料",
    categorySlug: "exclusive",
    coverImage: "https://readdy.ai/api/search-image?query=Luxury%20private%20dining%20room%20with%20round%20table%20and%20empty%20chairs%2C%20dim%20warm%20ambient%20lighting%2C%20elegant%20chandelier%2C%20mysterious%20atmosphere%2C%20high-end%20restaurant%20interior%2C%20dramatic%20shadows%2C%20suspenseful%20mood&width=800&height=600&seq=article-cover-06&orientation=landscape",
    author: "财经调查组",
    publishDate: "2026-06-26",
    views: 589000,
    tags: ["上市公司", "CEO", "内幕交易", "独家爆料"],
    featured: true,
  },
  {
    id: 7,
    title: "快递小哥暴雨中护送老人回家，暖心一幕感动全网",
    excerpt: "一段快递小哥在暴雨中脱下自己的雨衣为老人遮雨、并护送其回家的视频在网上热传。",
    content: `<p>近日，一段快递小哥在暴雨中护送老人的视频在社交平台广为流传，感动了无数网友。</p><p>视频显示，某城市突降暴雨，一位老人因没有带伞，在路边屋檐下焦急等待。一名路过的快递小哥看到后，毫不犹豫地脱下自己的雨衣披在老人身上，自己则淋着雨，一手扶着老人，一手推着快递车，将老人安全送回了家。</p><p>"当时雨太大了，我看老人家一个人站在那儿，腿脚也不太方便，心里就特别不是滋味。"事后接受采访时，这位名叫张强的快递小哥腼腆地说。</p><p>老人的女儿得知此事后，通过社交平台找到了这位快递小哥，想要当面感谢，但张强表示"这只是举手之劳"。</p><h2>社会反响</h2><p>该视频发出后，迅速获得数百万点赞。张强所在的快递公司也对他进行了表彰和奖励。网友纷纷评论："这才是真正的正能量"、"平凡的人给我们最多感动"。</p>`,
    category: "正能量",
    categorySlug: "positive",
    coverImage: "https://readdy.ai/api/search-image?query=Rainy%20city%20street%20scene%20with%20warm%20golden%20streetlight%20reflections%20on%20wet%20pavement%2C%20gentle%20rainfall%2C%20cozy%20urban%20atmosphere%2C%20kindness%20theme%2C%20soft%20focus%20background%2C%20warm%20tones%2C%20emotional%20storytelling%20photography&width=800&height=600&seq=article-cover-07&orientation=landscape",
    author: "温暖传递者",
    publishDate: "2026-06-25",
    views: 723000,
    tags: ["快递小哥", "暴雨", "暖心", "正能量"],
    featured: true,
  },
  {
    id: 8,
    title: "某选秀节目选手被曝买票刷榜，节目组紧急回应",
    excerpt: "有网友通过数据分析发现某选手的票数存在异常增长模式，引发对选秀公平性的质疑。",
    content: `<p>热门选秀节目《星光之路》播出至今，一直保持着高话题度。然而近日，有细心的网友通过数据分析发现，某位人气选手的票数增长曲线存在明显异常。</p><p>该网友在技术论坛发布的分析报告显示，该选手的票数在每日凌晨3点至5点之间会出现集中暴增，增长模式呈现出机器刷票的典型特征。而同一时间段，其他选手的票数几乎没有任何变化。</p><p>"正常的粉丝投票应该是在白天和晚上的黄金时段比较活跃，凌晨基本上是投票低谷。但这个选手的数据完全反过来了。"分析报告指出。</p><p>此事引发大量观众不满，纷纷要求节目组彻查。</p><h2>官方回应</h2><p>节目组随后发布声明，表示将联合第三方技术团队对投票系统进行全面审查，如发现刷票行为，将取消相关票数并对责任人追责。同时，节目组承诺将加强投票系统的防作弊机制。</p>`,
    category: "娱乐圈",
    categorySlug: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Talent%20show%20stage%20with%20colorful%20spotlights%20and%20empty%20audience%20seats%2C%20dramatic%20lighting%20effects%2C%20competition%20atmosphere%2C%20grand%20studio%20setting%2C%20vibrant%20warm%20neon%20tones%2C%20entertainment%20industry%20vibe&width=800&height=600&seq=article-cover-08&orientation=landscape",
    author: "选秀观察家",
    publishDate: "2026-06-24",
    views: 267000,
    tags: ["选秀节目", "刷票", "公平性", "节目组"],
    featured: false,
  },
  {
    id: 9,
    title: "某网红探店被店家实锤\"白吃白喝还索要好处费\"",
    excerpt: "一家餐厅老板公开发文，指控某探店网红以差评相威胁索要\"合作费\"，引发行业大讨论。",
    content: `<p>近日，某城市一家火锅店老板在社交平台发布长文，实名指控一名拥有百万粉丝的探店网红存在"白吃白喝还索要好处费"的行为。</p><p>据该老板描述，这名网红上个月带着团队共6人到店里用餐，消费金额约3000元。用餐结束后，网红通过助理联系店家，表示"如果给8000元合作费就可以出一个好评视频，否则可能评价不会太好"。</p><p>"我当场就拒绝了，我们是做正经生意的。"该老板写道。随后，该网红果然发布了一条关于该店的负面评价视频，导致店铺评分在短时间内大幅下降。</p><p>该老板表示已经保留了所有聊天记录和通话录音，准备通过法律途径维权。</p><h2>行业乱象</h2><p>此事曝光后，多家餐饮从业者纷纷站出来分享类似的遭遇，揭示了探店行业存在的"吃霸王餐"和"以评勒索"等乱象。有业内人士呼吁平台应加强对探店类内容的监管和审核。</p>`,
    category: "网红圈",
    categorySlug: "influencer",
    coverImage: "https://readdy.ai/api/search-image?query=Stylish%20hotpot%20restaurant%20interior%20with%20empty%20tables%20and%20warm%20ambient%20lighting%2C%20modern%20Chinese%20dining%20environment%2C%20elegant%20decor%2C%20steam%20rising%20from%20pot%2C%20cozy%20atmosphere%2C%20food%20photography%20style&width=800&height=600&seq=article-cover-09&orientation=landscape",
    author: "餐饮观察",
    publishDate: "2026-06-23",
    views: 176000,
    tags: ["探店网红", "霸王餐", "勒索", "行业乱象"],
    featured: false,
  },
  {
    id: 10,
    title: "笑喷了！大叔模仿网红跳舞翻车现场，网友：这才是真实力",
    excerpt: "一位中年大叔在公园尝试模仿热门网红舞蹈，结果各种翻车，意外走红网络。",
    content: `<p>最近，一段大叔在公园跳网红舞蹈的视频在社交平台火爆出圈，原因不是跳得好，而是跳得实在太"魔性"了。</p><p>视频中，一位约五十多岁的大叔在公园空地上，伴随着热门网红舞蹈的音乐，认真地模仿每一个动作。然而由于身体协调性的原因，大叔的舞姿与原创者形成了鲜明的反差——该扭的地方不扭，不该扭的地方扭得特别卖力。</p><p>"我每天在公园锻炼，看到年轻人跳这个觉得挺有意思的，就想试试。"大叔在后续采访中笑着说，"没想到这么难，年轻人们太厉害了！"</p><p>这段视频发出后，不仅没有遭到嘲笑，反而收获了大量点赞和暖心评论。网友纷纷表示："这才是真正的快乐"、"大叔跳出了自己的风格"、"笑死我了但真的很可爱"。</p><h2>意外走红</h2><p>更有趣的是，该网红本尊也看到了这个视频，并在评论区留言"大叔比我跳得好"，还主动提出要当面教大叔跳舞。这一互动又引发了一波新的讨论热潮。</p>`,
    category: "搞笑吃瓜",
    categorySlug: "funny",
    coverImage: "https://readdy.ai/api/search-image?query=Sunny%20park%20scene%20with%20green%20grass%20and%20trees%2C%20outdoor%20exercise%20area%2C%20bright%20warm%20sunlight%2C%20cheerful%20happy%20atmosphere%2C%20leisure%20lifestyle%2C%20natural%20warm%20tones%2C%20positive%20vibe%20photography&width=800&height=600&seq=article-cover-10&orientation=landscape",
    author: "欢乐吃瓜人",
    publishDate: "2026-06-22",
    views: 891000,
    tags: ["搞笑", "大叔跳舞", "翻车", "网红"],
    featured: true,
  },
  {
    id: 11,
    title: "某知名综艺节目录制现场发生意外，嘉宾被紧急送医",
    excerpt: "据现场观众爆料，某户外竞技类综艺在录制过程中发生安全事故，一名嘉宾受伤被送往医院。",
    content: `<p>据多名现场观众爆料，某知名户外竞技类综艺节目在昨日录制过程中发生安全事故，一名常驻嘉宾在完成挑战项目时不慎受伤，被紧急送往医院。</p><p>据悉，事故发生在节目组设置的一个高空挑战环节中。该嘉宾在完成跳跃动作后，安全绳出现异常，导致其从约三米高的位置坠落，虽然下方有保护垫，但该嘉宾仍然出现了明显的疼痛反应。</p><p>"当时我们都吓坏了，录制立刻停止了。工作人员围了上去，过了大概十分钟救护车就到了。"一位现场观众描述道。</p><p>节目组在事发后第一时间发布了声明，表示该嘉宾经医院检查后确认无大碍，只是轻微的腰部扭伤，目前已经出院休养。节目组也已对相关设备进行了全面排查和整改。</p><h2>粉丝担忧</h2><p>尽管节目组表示嘉宾无大碍，但粉丝们仍然对节目组的安全保障措施表示担忧，纷纷在官方账号下留言，要求节目组提高安全标准，杜绝类似事件再次发生。</p>`,
    category: "娱乐圈",
    categorySlug: "entertainment",
    coverImage: "https://readdy.ai/api/search-image?query=Outdoor%20adventure%20challenge%20course%20with%20safety%20equipment%20and%20ropes%2C%20sunlight%20filtering%20through%20trees%2C%20reality%20show%20set%20vibe%2C%20dramatic%20natural%20lighting%2C%20action%20sports%20atmosphere%2C%20warm%20outdoor%20tones&width=800&height=600&seq=article-cover-11&orientation=landscape",
    author: "综艺前线",
    publishDate: "2026-06-21",
    views: 234000,
    tags: ["综艺节目", "安全事故", "嘉宾受伤", "录制"],
    featured: false,
  },
  {
    id: 12,
    title: "独家揭秘：某知名MCN机构内部管理混乱，多名网红集体出走",
    excerpt: "据多位知情人士向本网爆料，某头部MCN机构近期出现大规模人才流失，背后原因令人深思。",
    content: `<p>本网近日从多位知情人士处获悉，某拥有超过两百名签约网红的头部MCN机构近期遭遇了严重的人才流失危机。</p><p>据不完全统计，仅最近三个月内，该机构就有超过30名签约网红选择解约或不再续约，其中包括多名粉丝量超过500万的头部达人。这一数字远超行业正常流动水平。</p><p>"最主要的问题是分成比例不合理。"一位已经离开该机构的网红匿名透露，"机构要拿走直播打赏的70%，广告收入的60%。而且合同里还有很多霸王条款，比如三年内不能换平台，违约金高得吓人。"</p><p>除分成问题外，该机构的内部管理也被指混乱。有知情人士透露，机构内部的经纪人之间经常为了争夺优质网红而互相倾轧，导致网红们不堪其扰。</p><h2>行业影响</h2><p>该事件引发了行业对MCN机构管理模式的广泛讨论。多位行业专家指出，随着网红经济的成熟，传统的"压榨式"管理模式已不可持续，MCN机构需要建立更加公平合理的利益分配机制。</p>`,
    category: "独家黑料",
    categorySlug: "exclusive",
    coverImage: "https://readdy.ai/api/search-image?query=Modern%20open%20office%20space%20with%20empty%20desks%20and%20chairs%2C%20corporate%20environment%20with%20warm%20lighting%2C%20slightly%20abandoned%20atmosphere%2C%20glass%20walls%2C%20creative%20workspace%2C%20after-hours%20vibe%2C%20professional%20setting&width=800&height=600&seq=article-cover-12&orientation=landscape",
    author: "行业深喉",
    publishDate: "2026-06-20",
    views: 198000,
    tags: ["MCN", "网红出走", "分成", "行业"],
    featured: false,
  },
];

export const testimonials = [
  {
    id: 1,
    name: "李总",
    role: "资深媒体人",
    quote: "吃瓜网是我每天必看的平台，信息更新速度全网第一。很多独家爆料都是在这里首发，做媒体这么多年，很少有平台能做到这种程度。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20middle-aged%20Chinese%20man%20in%20business%20casual%20attire%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20friendly%20expression%2C%20headshot%20photography&width=200&height=200&seq=testimonial-01&orientation=squarish",
    verified: true,
  },
  {
    id: 2,
    name: "王小花",
    role: "忠实读者",
    quote: "从吃瓜网创立第一天就开始关注了，内容越来越丰富。最让我感动的是，除了八卦还有正能量的内容，让我在吃瓜的同时也能感受到温暖。",
    avatar: "https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20casual%20style%2C%20natural%20studio%20lighting%2C%20clean%20background%2C%20friendly%20approachable%20look%2C%20headshot%20photography&width=200&height=200&seq=testimonial-02&orientation=squarish",
    verified: true,
  },
  {
    id: 3,
    name: "张老师",
    role: "自媒体博主",
    quote: "作为一个内容创作者，吃瓜网给了我很多灵感。他们的选题角度总是能抓住热点核心，而且内容质量在同类平台中是数一数二的。",
    avatar: "https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20Chinese%20man%20in%20his%20thirties%2C%20modern%20casual%20style%2C%20warm%20studio%20lighting%2C%20clean%20white%20background%2C%20confident%20expression%2C%20portrait%20photography&width=200&height=200&seq=testimonial-03&orientation=squarish",
    verified: true,
  },
];